export default __webpack_public_path__ + "static/media/JoinConnect.8de7e2e7.svg";